import { useMutation } from '@tanstack/react-query';

import {
  type GetVoucherOrderAutoAssignResponse,
  type ManualVoucherAutoAssignPayload,
  type ManualVoucherAutoAssignResponse,
  getVoucherOrderAutoAssign,
  manualVoucherAutoAssign,
} from '~/services/PromoService';

export function useDryRunVoucherOrderAutoAssign() {
  return useMutation<GetVoucherOrderAutoAssignResponse, Error, string>({
    mutationFn: (orderId) => getVoucherOrderAutoAssign(orderId),
  });
}

export function useManualVoucherOrderAutoAssign() {
  return useMutation<ManualVoucherAutoAssignResponse, Error, ManualVoucherAutoAssignPayload>({
    mutationFn: (payload) => manualVoucherAutoAssign(payload),
  });
}
